const en_rka_planning = {
    "": "planning",
    add: "create plan",
    edit: "edit plan",
}

export default en_rka_planning;